import { render } from "./TopNavbar.vue?vue&type=template&id=a0a1241a&ts=true"
import script from "./TopNavbar.vue?vue&type=script&lang=ts"
export * from "./TopNavbar.vue?vue&type=script&lang=ts"

import "./TopNavbar.vue?vue&type=style&index=0&id=a0a1241a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__